import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    disallowNegatives: Boolean,
    maxDecimals: Number,
    max: Number
  }

  connect() {
    if (this.disallowNegativesValue) {
      this.element.setAttribute('min', 0)
    }

    this.element.addEventListener('beforeinput', e => {
      // prohibit negative numbers if disallowed
      if (this.disallowNegativesValue && e.data?.includes('-')) {
        e.preventDefault()
      }
    })

    this.element.addEventListener('input', e => {
      this.validateInput(e)
    })
  }

  validateInput(event) {
    const input = event.target
    let value = input.value

    if (this.hasMaxDecimalsValue) {
      if (this.maxDecimalsValue === 0) {
        // Remove any decimal points and everything after them for integers
        if (value.includes('.')) {
          input.value = Math.floor(parseFloat(value)) || ''
          value = input.value
        }
      } else {
        // Limit to specified number of decimal places
        const parts = value.split('.')
        if (parts.length > 1 && parts[1].length > this.maxDecimalsValue) {
          input.value = parseFloat(value).toFixed(this.maxDecimalsValue)
          value = input.value
        }
      }
    }

    // Enforce max value if specified
    if (this.hasMaxValue) {
      const numValue = parseFloat(value)
      if (numValue > this.maxValue) {
        if (this.hasMaxDecimalsValue && this.maxDecimalsValue > 0) {
          input.value = this.maxValue.toFixed(this.maxDecimalsValue)
        } else {
          input.value = this.maxValue.toString()
        }
      }
    }
  }
}
